import React, { useState, useEffect, useContext } from "react";
import "./premiumFeature.css";
import Avatar from "@mui/material/Avatar";
import Chip from '@mui/material/Chip';
import Alert from "../../components/common/Alert";
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Button, Box, Typography } from "@mui/material";
import NotificationBell from "../../components/common/NotificationBell";
import MessageInbox from "./MessageInbox";
import { API } from "../../api/axios";
import { messagingApi } from "../../api/messagingApi";
import { NotificationContext } from "../../context/NotificationContext";

const ActorInvitation = () => {
  const [messages, setMessages] = useState([]);
  const [applications, setApplications] = useState([]);
  const [selectedMessage, setSelectedMessage] = useState(null);

  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [alertSeverity, setAlertSeverity] = useState("success");
  const [alertMessage, setAlertMessage] = useState("");

  const [openDialog, setOpenDialog] = useState(false);
  const [pendingRejectId, setPendingRejectId] = useState(null);

  const notificationContext = useContext(NotificationContext);
  const fetchNotifications = notificationContext?.fetchNotifications || (() => { });
  const fetchUnreadCount = notificationContext?.fetchUnreadCount || (() => { });
  const userId = localStorage.getItem("userId");

  useEffect(() => {
    if (userId) {
      API.get(`/invite/getRoleList/userId/${userId}`)
        .then((response) => {
          const data = response?.data;
          if (data && Array.isArray(data.invitations)) {
            setMessages(data.invitations);
            if (data.invitations.length > 0) {
              setSelectedMessage(data.invitations[0]);
            }
          }
        })
        .catch((error) => console.error("Error fetching data:", error));
    }
  }, [userId]);

  useEffect(() => {
    if (userId) {
      API.get(`/apply/getAllApplicationsByUserId/${userId}`)
        .then((response) => {
          const data = response?.data;
          if (data && Array.isArray(data.applications)) {
            setApplications(data.applications);
          }
        })
        .catch((error) => console.error("Error fetching applications:", error));
    }
  }, [userId]);

  const updateInviteStatus = (invitationId, status) => {
    API.patch(`/invite/updateInviteStatus/invitationId/${invitationId}/inviteStatus/${status}`)
      .then((response) => {
        if (response.status !== 200) throw new Error(`HTTP error! Status: ${response.status}`);
        const data = response?.data;
        setAlertMessage(`Successfully Updated! ${data.invitations.inviteStatus}`);
        setAlertSeverity("success");
        setOpenSnackbar(true);

        // Refresh notifications
        fetchNotifications();
        fetchUnreadCount();

        setTimeout(() => {
          window.location.reload();
        }, 1500);
      })
      .catch((error) => console.error("Error updating invite status:", error));
  };

  const handleRejectClick = (invitationId) => {
    setPendingRejectId(invitationId);
    setOpenDialog(true);
  };

  const handleConfirmReject = () => {
    if (pendingRejectId) {
      updateInviteStatus(pendingRejectId, "reject");
    }
    setOpenDialog(false);
  };

  const handleCancelReject = () => {
    setOpenDialog(false);
  };

  console.log("selectedMessage", selectedMessage);
  return (
    <div className="main-container">
      {/* Header with Notification Bell */}


      <div className="sidebar-container">
        <Box sx={{ backgroundColor: "#f5f5f5", py: 2, mb: 3, borderBottom: "1px solid #e0e0e0", px: 2 }}>
          <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <Typography variant="h5" sx={{ fontWeight: 600 }}>
              Casting Invitations & Applications
            </Typography>
            {/* <NotificationBell /> */}
          </Box>
        </Box>
        {/* Invitation field */}
        <h4>Invitations</h4>
        <div className="message-list">
          {messages.length > 0 ? (
            messages.map((message) => (
              <div className="message-item-container" key={message.id} onClick={() => setSelectedMessage(message)}>
                <Avatar alt={message?.caller?.firstName} src={message.caller.imageURL} />
                <div className={`message-item ${selectedMessage?.id === message.id ? "active" : ""}`}>
                  {message?.caller?.firstName} {message?.caller?.lastName}
                </div>
              </div>
            ))
          ) : (
            <p>No invitations available</p>
          )}
        </div>
        <hr />
        {/* Application field */}
        <h4>Applications</h4>
        <div className="message-list">
          {applications.length > 0 ? (
            applications?.map((application) => (
              <div className="application-item-container" key={application.id} onClick={() => setSelectedMessage(application)}>
                <div className={`message-item ${selectedMessage?.id === application.id ? "active" : ""}`}>
                  {application?.casting?.title}
                </div>
              </div>
            ))
          ) : (
            <p>No applications available</p>
          )}
        </div>
      </div>

      <div className="message-container">
        <div className="invitation-header">
          <h1>
            {messages.some(msg => msg.id === selectedMessage?.id) ? "Casting Call - Invitation" : "Casting Call - Application"}
          </h1>
        </div>
        <hr />
        <div className="message-card">
          {selectedMessage ? (
            <>
              <div className="message-header">
                <h1>
                  {messages.some(msg => msg.id === selectedMessage?.id) ? "Invited by" : "Called by"}
                  {" "}
                  {selectedMessage?.caller?.firstName} {selectedMessage?.caller?.lastName}
                </h1>
                <Chip label={selectedMessage?.inviteStatus || selectedMessage?.castingApproval} />
              </div>
              <h3 className="casting-title">Casting Title: {selectedMessage?.casting?.title}</h3>
              <hr />
              <p>Description:</p>
              <p className="description">{selectedMessage?.casting?.shortDesc}</p>
              <div className="message-details">
                <div className="message-details-column">
                  <div>
                    <label className="details">Area:</label>
                    <span className="value">
                      {selectedMessage?.casting?.area === 'world'
                        ? 'Worldwide'
                        : selectedMessage?.casting?.area === 'nation'
                          ? 'Nationwide'
                          : selectedMessage?.casting?.area === 'local'
                            ? 'Local'
                            : ''}
                    </span>
                  </div>
                  <div>
                    <label className="details">Category:</label>
                    <span className="value">{selectedMessage?.casting?.category}</span>
                  </div>
                  <div>
                    <label className="details">Company Name:</label>
                    <span className="value">{selectedMessage?.casting?.companyName}</span>
                  </div>
                  <div>
                    <label className="details">Amount:</label>
                    <span className="value">$ {selectedMessage?.casting?.amount} per {selectedMessage?.casting?.period}</span>
                  </div>
                </div>
                <div className="message-details-column">
                  <div>
                    <label className="details">Role:</label>
                    <span className="value">{selectedMessage?.castingRole}</span>
                  </div>
                  <div>
                    <label className="details">Expire Date:</label>
                    <span className="value">{selectedMessage?.casting?.expirationDate}</span>
                  </div>
                </div>
              </div>

              <div className="button-container">
                {selectedMessage.inviteStatus === "pending" && (
                  <>
                    <button className="accept-btn" onClick={() => updateInviteStatus(selectedMessage.id, "approve")}>
                      Approve
                    </button>
                    <button className="reject-btn" onClick={() => handleRejectClick(selectedMessage.id)}>
                      Reject
                    </button>
                  </>
                )}
                {selectedMessage.inviteStatus === "approve" && (
                  <button className="reject-btn" onClick={() => handleRejectClick(selectedMessage.id)}>
                    Reject
                  </button>
                )}
              </div>

              {/* Message Inbox */}
              <Box sx={{ mt: 3 }}>
                <Typography variant="h6" sx={{ fontWeight: 600, mb: 2 }}>
                  Messages
                </Typography>
                <MessageInbox
                  selectedMessage={selectedMessage}
                  castingId={selectedMessage?.casting?.id}
                />
              </Box>
            </>
          ) : (
            <p>No message selected</p>
          )}
        </div>
      </div>

      <Dialog open={openDialog} onClose={handleCancelReject}>
        <DialogTitle>Confirm Rejection</DialogTitle>
        <DialogContent>
          <DialogContentText>Are you sure you want to reject this invitation?</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleConfirmReject} color="secondary">
            Yes
          </Button>
          <Button onClick={handleCancelReject} color="primary">
            No
          </Button>
        </DialogActions>
      </Dialog>

      <Alert openSnackbar={openSnackbar} alertSeverity={alertSeverity} setOpenSnackbar={setOpenSnackbar} alertMessage={alertMessage} />
    </div>
  );
};

export default ActorInvitation;